import { Box } from "@mui/material";
import PurpleLockSvg from "../../common/svgs/purpleLock.svg?react";
import { PlanTabContent } from "./PlanTabs.tsx";

export function getPlanTab(label: string, content: JSX.Element, index: number, hasAccess: boolean, tooltip: string, disabled?: boolean): PlanTabContent {
    return {
        label: label,
        content: content,
        index: index,
        disabled: disabled,
        disableAccess: !hasAccess,
        icon: !hasAccess ? (
            <Box sx={{ marginLeft: 0.5 }}>
                <PurpleLockSvg />
            </Box>
        ) : undefined,
        tooltip: !hasAccess ? tooltip : "",
    };
}
